// tslint:disable:max-line-length

import React from 'react';

export const LogoFacebook = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M.875 0c-.488 0-.875.387-.875.875v14.25c0 .488.387.875.875.875h7.656v-6.188h-2.063v-2.438h2.063v-1.781c0-2.067 1.281-3.188 3.125-3.188.883 0 1.623.065 1.844.094v2.156l-1.25.031c-1.003 0-1.219.456-1.219 1.156v1.531h2.406l-.313 2.438h-2.094v6.188h4.094c.488 0 .875-.387.875-.875v-14.25c0-.488-.387-.875-.875-.875h-14.25z" />
    </svg>
  );
};
